<template>
  <div class="filter-set more-filters-set">
    <button
      class="filter-name more-filters"
      @click.stop="$emit('toggle')"
      :aria-expanded="expanderVisible ? 'true' : 'false'"
      aria-controls="filter-box-content"
    >
      <span class="filter-name__label">Lisää hakuehtoja</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </button>
    <expander :expanded="expanderVisible">
      <filter-box :rowFilters="rowFilters" :filters="filters"></filter-box>
    </expander>
  </div>
</template>
<script lang="ts">
import Expander from '../expander/expander.vue';
import FilterBox from './filter-box.vue';
export default {
  name: 'more-filters',
  props: {
    rowFilters: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    expanderVisible: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Expander,
    FilterBox,
  },
};
</script>
